module.exports = "https://static.wanderu.com/static/media/chiku-wink.e958e6c1.svg";